import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Form,
  Row,
  Col,
  Button,
  Table,
  Card,
  InputGroup,
} from "react-bootstrap";
import { FaRegEyeSlash, FaEye, FaRegEye } from "react-icons/fa";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { BiUpload } from "react-icons/bi";

const Profile = () => {
  const { data, fetchData } = useContext(UserContext);
  const navigate = useNavigate();
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const [formData, setFormData] = useState({});
  const [showBtn, setShowBtn] = useState(false)
  const [imagePreview, setImagePreview] = useState(null);
  const FileInputRef = useRef(null);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState({
    currentPassword: false,
    newPassword: false,
    confirmPassword: false,
  });
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = {
    "auth-token": authToken,
    authorization: accessToken,
  };

  const [load, setLoad] = useState(false);
  const [loadP, setLoadP] = useState(false);

  useEffect(() => {
    setFormData({
      fullname: data?.fullname || "",
      email: data?.email || "",
      profile_pic: data?.profile_pic || "",
    })
    setImagePreview(data?.profile_pic)
  }, [data])
  const togglePasswordVisibility = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };
  const handlePasswordChange = (e) => {
    const { name, value } = e.target;

    // Update the corresponding state
    if (name === "currentPassword") {
      setCurrentPassword(value);
    } else if (name === "newPassword") {
      setNewPassword(value);
    } else if (name === "confirmPassword") {
      setConfirmPassword(value);
    }

    // Clear the error for the specific field if it exists
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };
  const validate = () => {
    const errors = {};

    if (!currentPassword) {
      errors.currentPassword = "Current password is required.";
    } else if (currentPassword.length < 6) {
      errors.currentPassword = "Password must be at least 6 characters.";
    } else if (currentPassword.length > 20) {
      errors.currentPassword = "Password must not exceed 20 characters.";
    }

    if (!newPassword) {
      errors.newPassword = "New password is required.";
    } else if (newPassword.length < 6) {
      errors.newPassword = "Password must be at least 6 characters.";
    } else if (newPassword.length > 20) {
      errors.newPassword = "Password must not exceed 20 characters.";
    }

    if (!confirmPassword) {
      errors.confirmPassword = "Please confirm your new password.";
    } else if (confirmPassword !== newPassword) {
      errors.confirmPassword = "Passwords do not match.";
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const onImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prevState) => ({
        ...prevState,
        profile_pic: file,
      }));
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setImagePreview(null);
      setFormData((prevState) => ({
        ...prevState,
        profile_pic: null,
      }));
    }
  };
  const validateP = () => {
    const newErrors = {};
    if (!formData.fullname) newErrors.fullname = "Full Name is required.";

    if (!formData.email) {
      newErrors.email = "Email address is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email address is invalid.";
    }
    if (formData.profile_pic && formData.profile_pic instanceof File) {
      if (
        !["image/jpeg", "image/png", "image/gif"].includes(
          formData.profile_pic.type
        )
      ) {
        newErrors.profile_pic = "Profile picture must be a JPG, PNG, or GIF";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "profile_pic" && files.length > 0) {
      const file = files[0];
      setFormData((pre) => ({ ...pre, profile_pic: file }));
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    } else {
      setFormData((pre) => ({ ...pre, [name]: value }));
    }
    setErrors({ ...errors, [name]: "" });
  };

  const handleSubmitP = async (e) => {
    e.preventDefault();
    setLoadP(true);
    if (validateP()) {
      const payload = {
        fullname: formData?.fullname || "",
        email: formData?.email || "",
        profile_pic: formData?.profile_pic || "",
      };

      const formDataToSubmit = new FormData();
      Object.keys(payload).forEach((key) => {
        formDataToSubmit.append(key, payload[key]);
      });
      const res = await APIServices.post(
        "admin/auth/update_profile",
        formDataToSubmit,
        { "content-type": "multipart/form-data", ...headers }
      );
      if (res?.data?.status === true) {
        setLoadP(false);
        let data = res?.data;

        showToast(res?.data?.message || "Success", "success");
        fetchData()
        setTimeout(() => {
          navigate("/admin/dashboard");
        }, 2000);
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
        setLoadP(false);
      }
    }
    setLoadP(false);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoad(true);

    if (validate()) {
      const payload = {
        new_password: newPassword,
        current_password: currentPassword,
      };
      const res = await APIServices.post(
        "admin/auth/change_password",
        payload,
        headers
      );
      if (res?.data?.status === true) {
        setLoad(false);
        let data = res?.data;

        showToast(res?.data?.message || "Success", "success");
        setTimeout(() => {
          navigate("/admin/dashboard");
        }, 2000);
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
        setLoad(false);
      }
    }
    setLoad(false);
  };
  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };
  return (
    <>
      <div className="profile_sec">
        <h1 className="font_blue_18 font-600 mb-3">Profile</h1>

        <div className="Puser_info d-flex justify-content-between align-items-center   mb-3">
          <div className="d-flex align-items-center gap-3">
            <span className="position-relative">
              {
                data?.profile_pic ?
                  <img
                    src={data.profile_pic}
                    data="img-fluid me-2 table_user"
                    alt={data.first_name}
                    onError={(e) => (e.target.src = "/images/placeholder-img.jpg")}
                  />
                  :
                  <img src="/images/placeholder-img.jpg"
                    className='img-fluid me-2 table_user'
                    alt="default img"
                  />
              }
              {/* <img src="/images/red_cam.png" className='img-fluid icon' alt="images" /> */}
            </span>
            <div className="name_sec">
              <span className="d-flex">
                <h4 className="font_blue_18 font-500 mb-2 textTransform">
                  {data?.fullname}
                </h4>
                ({data?.user_type})
              </span>
              <p className="font_blue_16">{data?.email}</p>
            </div>
          </div>
          <Button
            className="red_button"
            onClick={() => setShowBtn(prev => !prev)} // toggle current state
          >
            Edit
          </Button>
        </div>


        {showBtn && (<>
          <div className="update_profile">
            <h2 className="font_blue_18 font-600 mb-2">Update Profile</h2>
            <form>
              <Row>
                <Col md={12} lg={12}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Profile
                    </Form.Label>
                    <div className="d-flex flex-column ">
                      <label htmlFor="upload-input" className="upload-circle">
                        {imagePreview ? (
                          <img
                            src={imagePreview}
                            alt="Uploaded"
                            className="uploaded-img"
                          />
                        ) : (
                          <BiUpload size={30} color="#333" />
                        )}
                      </label>
                      <Form.Control
                        type="file"
                        name="profile_pic"
                        className="d-none"
                        id="upload-input"
                        accept="image/jpeg,image/png,image/gif"
                        onChange={(e) => {
                          onImageChange(e);
                          handleChange(e);
                        }}
                        ref={FileInputRef}
                        isInvalid={!!errors.profile_pic}
                      />
                    </div>

                    {errors.profile_pic && (
                      <div className="text-danger mt-2">{errors.profile_pic}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} lg={6}>
                  <Form.Group controlId="fullName">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Full Name
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="fullname"
                        placeholder="Enter Your Full Name"
                        value={formData.fullname}
                        onChange={handleChange}
                      />
                    </InputGroup>
                    {errors.fullname && (
                      <div className="text-danger mt-2">{errors.fullname}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} lg={6}>
                  <Form.Group controlId="emailId">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Email
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Enter Email ID"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </InputGroup>
                    {errors.email && (
                      <div className="text-danger mt-2">{errors.email}</div>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <div className="d-flex justify-content-end gap-2 mt-3">
                <Button
                  className="btn blue_border"
                  onClick={() => setShowBtn(prev => !prev)}
                >
                  Cancel
                </Button>
                <Button
                  className="btn red_button"
                  onClick={handleSubmitP}
                  disabled={loadP}
                >
                  {load ? "Processing..." : "Update"}
                </Button>
              </div>
            </form>
          </div>
        </>)}

        <div className="change_password">
          <h2 className="font_blue_18 font-600 mb-2">Change Password</h2>

          <form>
            <Row>
              <Col md={4} lg={4}>
                <Form.Group controlId="currentPassword">
                  <Form.Label className="font_blue_14 font-500 mb-2 ">
                    Current Password
                  </Form.Label>
                  <InputGroup>
                    <Form.Control
                      type={showPassword.currentPassword ? "text" : "password"}
                      name="currentPassword"
                      placeholder="Enter Current Password"
                      value={currentPassword}
                      onChange={handlePasswordChange}
                    />
                    <InputGroup.Text
                      variant="outline-secondary"
                      onClick={() =>
                        togglePasswordVisibility("currentPassword")
                      }
                    >
                      {showPassword.currentPassword ? (
                        <FaRegEye />
                      ) : (
                        <FaRegEyeSlash />
                      )}
                    </InputGroup.Text>
                  </InputGroup>
                  {errors.currentPassword && (
                    <div className="text-danger mt-2">
                      {errors.currentPassword}
                    </div>
                  )}
                </Form.Group>
              </Col>

              <Col md={4} lg={4}>
                <Form.Group controlId="newPassword">
                  <Form.Label className="font_blue_14 font-500 mb-2 ">
                    New Password
                  </Form.Label>
                  <InputGroup>
                    <Form.Control
                      type={showPassword.newPassword ? "text" : "password"}
                      name="newPassword"
                      placeholder="Enter New Password"
                      value={newPassword}
                      onChange={handlePasswordChange}
                    />
                    <InputGroup.Text
                      onClick={() => togglePasswordVisibility("newPassword")}
                    >
                      {showPassword.newPassword ? (
                        <FaRegEye />
                      ) : (
                        <FaRegEyeSlash />
                      )}
                    </InputGroup.Text>
                  </InputGroup>
                  {errors.newPassword && (
                    <div className="text-danger mt-2">{errors.newPassword}</div>
                  )}
                </Form.Group>
              </Col>

              <Col md={4} lg={4}>
                <Form.Group controlId="confirmPassword">
                  <Form.Label className="font_blue_14 font-500 mb-2 ">
                    Confirm New Password
                  </Form.Label>
                  <InputGroup>
                    <Form.Control
                      type={showPassword.confirmPassword ? "text" : "password"}
                      name="confirmPassword"
                      placeholder="Enter Confirm New Password"
                      value={confirmPassword}
                      onChange={handlePasswordChange}
                    />
                    <InputGroup.Text
                      onClick={() =>
                        togglePasswordVisibility("confirmPassword")
                      }
                    >
                      {showPassword.confirmPassword ? (
                        <FaRegEye />
                      ) : (
                        <FaRegEyeSlash />
                      )}
                    </InputGroup.Text>
                  </InputGroup>
                  {errors.confirmPassword && (
                    <div className="text-danger mt-2">
                      {errors.confirmPassword}
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <div className="d-flex justify-content-end gap-2 mt-3">
              <Button
                className="btn blue_border"
                onClick={() => navigate("/admin/dashboard")}
              >
                Cancel
              </Button>
              <Button
                className="btn red_button"
                onClick={handleSubmit}
                disabled={load}
              >
                {load ? "Processing..." : "Update"}
              </Button>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default Profile;
